import gql from 'graphql-tag';

const MIGRATE_SIGNUPS_TO_PRISMA = gql`
  mutation MigrateSignupsToPrisma($campaignOrderId: ID!) {
    migrateSignupsToPrisma(campaignOrderId: $campaignOrderId) {
      success
      message
      signupsCount
      impressionsCount
      byDateCount
      error
    }
  }
`;

export default MIGRATE_SIGNUPS_TO_PRISMA;
